/**
 * 默认配置
 */
//globe 一个Cesium的Globe对象，表示地球。如果没有指定，会自动创建一个默认的对象。
//mapProjection  一个Cesium的MapProjection对象，表示地图投影方式。如果没有指定，会自动创建一个默认的对象。
//contextOptions 一个对象，用于配置WebGL选项，例如是否开启深度测试、是否启用顶点着色器等。可以参考MDN的WebGLRenderingContext文档进行配置
//clock 指定一个Cesium.Clock对象，用于控制时间流逝。如果没有指定，会自动创建一个
//terrainProvider 指定一个Cesium的TerrainProvider，用于提供地形数据。同样可以使用Cesium默认提供的地形服务，也可以使用自己的服务
//imageryProvider 指定一个Cesium的ImageryProvider，用于提供地图瓦片数据。可以使用Cesium默认提供的影像服务，也可以使用自己的服务
export let viewerCfig = {
    imageryProvider:false,
    terrainProvider: false,
    baseLayerPicker: false, //设置是否显示底图选择器
    geocoder: false,     //设置是否显示地名查询控件（例如搜索北京、天安门等名称）
    navigationHelpButton: false, //设置是否显示帮助按钮，在该按钮的弹出窗口中可以看到各种有用的快捷键、控制方式等
    fullscreenButton: false,  //设置是否显示全屏按钮
    sceneModePicker: true, //设置是否显示场景模式选择器（2D、3D等
    animation: false,    //设置是否显示动画控制按钮（用于控制时间）
    timeline: false,     //设置是否显示时间线
    selectionIndicator: false, //设置是否显示用于选择实体、构建点等的指示器
    homeButton: false,   //设置是否显示回到初始视角的按钮
    infoBox: false,      //设置是否显示弹出信息框
    shouldAnimate: true, //设置是否允许时间流逝，即是否开启动画
    maximumZoomDistance: 10000000,
    contextOptions: {
        webgl: {
            preserveDrawingBuffer: true, // 开启渲染缓冲区保留
            alpha: true
        }
    }
};

